import { IComponent } from 'src/interfaces';

/**
 * Build PATCH payloads only for components whose tag membership changed vs persisted.
 */
export const buildComponentTagAssignmentUpdates = (
  currentSelected: IComponent[],
  persistedSelected: IComponent[] | undefined,
  tagId: number,
): IComponent[] => {
  const persisted = persistedSelected ?? [];
  const initialIds = new Set(persisted.map((c) => c.id));
  const currentIds = new Set(currentSelected.map((c) => c.id));

  const removedIds = [...initialIds].filter((id) => !currentIds.has(id));
  const addedIds = [...currentIds].filter((id) => !initialIds.has(id));

  const updates: IComponent[] = [];

  for (const id of removedIds) {
    const component = persisted.find((c) => c.id === id);
    if (!component) continue;
    const nextTags =
      component.component_tag_id?.filter((tid) => tid !== tagId) ?? [];
    updates.push({ ...component, component_tag_id: nextTags });
  }

  for (const id of addedIds) {
    const component = currentSelected.find((c) => c.id === id);
    if (!component) continue;
    const tags = component.component_tag_id ?? [];
    updates.push({
      ...component,
      component_tag_id: tags.includes(tagId) ? tags : [...tags, tagId],
    });
  }

  return updates;
};
